module.exports = __webpack_public_path__ + "img/block.20360407.png";